

































import mixins from 'vue-typed-mixins'
import {
  ScriptRowVersionDesktop,
  ScriptRowVersionTablet,
  ScriptRowVersionMobile,
} from '@/components/Scripts/ScriptRowVersion/ScriptRowVersion'
import Collapse from '@/components/Collapse/Collapse.vue'
import Slider, { SliderItem } from '@/components/Slider/Slider.vue'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import { ScriptUnit } from '@/models/scripts'

interface Computed {
  showClass: string
  hasDraft: boolean
  hasActive: boolean
  rowComponentName: string
}

interface Props {
  show?: boolean
  item: ScriptUnit
}

export default mixins(WindowResizeListener).extend<{}, {}, Computed, Props>({
  components: {
    ScriptRowVersionDesktop,
    ScriptRowVersionTablet,
    ScriptRowVersionMobile,
    Slider,
    SliderItem,
    Collapse,
  },
  props: {
    show: {
      default: false,
    },
    item: {
      required: true,
    },
  },
  computed: {
    showClass(): string {
      return this.show ? '-show' : ''
    },
    hasDraft(): boolean {
      return (this.item.versions || []).some(v => !v.instance.date)
    },
    hasActive(): boolean {
      return (this.item.versions || []).some(v => v.active)
    },
    rowComponentName(): string {
      if (this.isDesktop) {
        return 'ScriptRowVersionDesktop'
      }
      if (this.isTablet) {
        return 'ScriptRowVersionTablet'
      }
      return 'ScriptRowVersionMobile'
    },
  },
})
